module.exports = {
	"2": {
		"0": {
			"73": 2,
			"102": 5,
			"257": 9,
			"307": 10,
			"318": 3,
			"352": 4,
			"403": 1,
			"443": 6,
			"599": 7,
			"743": 8,
			"744": 11
		},
		"1": {
			"21": 2,
			"83": 12,
			"122": 10,
			"129": 11,
			"138": 4,
			"182": 5,
			"195": 3,
			"366": 1,
			"557": 7,
			"607": 6,
			"863": 8,
			"885": 9
		},
		"2": {
			"22": 2,
			"84": 12,
			"123": 10,
			"130": 11,
			"139": 4,
			"183": 5,
			"196": 3,
			"367": 1,
			"558": 7,
			"608": 6,
			"864": 8,
			"886": 9
		},
		"3": {
			"23": 2,
			"85": 12,
			"124": 10,
			"131": 11,
			"140": 4,
			"184": 5,
			"197": 3,
			"368": 1,
			"559": 7,
			"609": 6,
			"865": 8,
			"887": 9
		},
		"4": {
			"24": 2,
			"86": 12,
			"125": 10,
			"132": 11,
			"141": 4,
			"185": 5,
			"198": 3,
			"369": 1,
			"560": 7,
			"610": 6,
			"866": 8,
			"888": 9
		},
		"5": {
			"25": 2,
			"87": 12,
			"126": 10,
			"133": 11,
			"142": 4,
			"186": 5,
			"199": 3,
			"370": 1,
			"561": 7,
			"611": 6,
			"867": 8,
			"889": 9
		},
		"6": {
			"26": 2,
			"88": 12,
			"127": 10,
			"134": 11,
			"143": 4,
			"187": 5,
			"200": 3,
			"371": 1,
			"562": 7,
			"612": 6,
			"868": 8,
			"890": 9
		},
		"7": {
			"27": 2,
			"89": 12,
			"128": 10,
			"135": 11,
			"144": 4,
			"188": 5,
			"201": 3,
			"372": 1,
			"563": 7,
			"613": 6,
			"869": 8,
			"891": 9
		}
	},
	"3": {
		"0": {
			"73": 2,
			"74": 12,
			"102": 5,
			"257": 10,
			"307": 11,
			"318": 3,
			"352": 4,
			"403": 1,
			"443": 7,
			"599": 8,
			"737": 6,
			"882": 9
		},
		"1": {
			"21": 2,
			"83": 8,
			"138": 5,
			"182": 6,
			"195": 3,
			"366": 1,
			"557": 7,
			"607": 13,
			"788": 9,
			"791": 14,
			"842": 10,
			"845": 11,
			"848": 12,
			"896": 4
		},
		"2": {
			"22": 2,
			"84": 8,
			"139": 5,
			"183": 6,
			"196": 3,
			"367": 1,
			"558": 7,
			"608": 13,
			"789": 9,
			"792": 14,
			"843": 10,
			"846": 11,
			"849": 12,
			"897": 4
		},
		"3": {
			"23": 2,
			"85": 8,
			"140": 5,
			"184": 6,
			"197": 3,
			"368": 1,
			"559": 7,
			"609": 13,
			"790": 9,
			"793": 14,
			"844": 10,
			"847": 11,
			"850": 12,
			"898": 4
		},
		"4": {
			"17": 2,
			"176": 3,
			"362": 1
		},
		"5": {
			"13": 2,
			"172": 3,
			"358": 1
		},
		"6": {
			"18": 2,
			"177": 3,
			"363": 1
		},
		"7": {
			"14": 2,
			"173": 3,
			"359": 1
		}
	},
	"4": {
		"0": {
			"73": 2,
			"74": 4,
			"102": 11,
			"137": 16,
			"257": 6,
			"281": 15,
			"307": 7,
			"318": 3,
			"319": 8,
			"320": 9,
			"352": 12,
			"403": 1,
			"443": 14,
			"599": 13,
			"755": 10,
			"798": 5,
			"882": 17,
			"927": 18
		},
		"1": {
			"21": 2,
			"83": 12,
			"138": 4,
			"182": 5,
			"195": 3,
			"366": 1,
			"557": 7,
			"607": 14,
			"836": 8,
			"896": 6,
			"903": 13,
			"909": 9,
			"914": 10,
			"920": 11
		},
		"2": {
			"22": 2,
			"84": 12,
			"139": 4,
			"183": 5,
			"196": 3,
			"367": 1,
			"558": 7,
			"608": 14,
			"837": 8,
			"897": 6,
			"904": 13,
			"910": 9,
			"915": 10,
			"921": 11
		},
		"3": {
			"23": 2,
			"85": 12,
			"140": 4,
			"184": 5,
			"197": 3,
			"368": 1,
			"559": 7,
			"609": 14,
			"838": 8,
			"898": 6,
			"905": 13,
			"911": 9,
			"916": 10,
			"922": 11
		},
		"4": {
			"24": 2,
			"86": 12,
			"141": 4,
			"185": 5,
			"198": 3,
			"369": 1,
			"560": 7,
			"610": 14,
			"839": 8,
			"899": 6,
			"906": 13,
			"912": 9,
			"917": 10,
			"923": 11
		},
		"5": {
			"25": 2,
			"87": 12,
			"142": 4,
			"186": 5,
			"199": 3,
			"370": 1,
			"561": 7,
			"611": 14,
			"840": 8,
			"900": 6,
			"907": 13,
			"913": 9,
			"918": 10,
			"924": 11
		},
		"6": {
			"26": 1,
			"88": 11,
			"143": 3,
			"187": 4,
			"200": 2,
			"371": 5,
			"562": 6,
			"901": 9,
			"908": 10,
			"919": 7,
			"925": 8
		},
		"7": {
			"17": 2,
			"176": 3,
			"362": 1
		},
		"8": {
			"13": 2,
			"172": 3,
			"358": 1
		},
		"9": {
			"18": 2,
			"177": 3,
			"363": 1
		},
		"10": {
			"14": 2,
			"173": 3,
			"359": 1
		},
		"11": {
			"19": 2,
			"178": 3,
			"364": 1
		},
		"12": {
			"15": 2,
			"174": 3,
			"360": 1
		},
		"13": {
			"20": 2,
			"179": 3,
			"365": 1
		},
		"14": {
			"16": 2,
			"175": 3,
			"361": 1
		}
	},
	"5": {
		"0": {
			"349": 2,
			"443": 3,
			"599": 4,
			"689": 1
		}
	},
	"6": {
		"0": {
			"73": 3,
			"82": 68,
			"102": 29,
			"257": 7,
			"296": 62,
			"297": 63,
			"298": 16,
			"299": 27,
			"305": 25,
			"307": 8,
			"308": 17,
			"309": 28,
			"315": 26,
			"318": 4,
			"320": 11,
			"328": 49,
			"329": 50,
			"330": 53,
			"331": 54,
			"332": 51,
			"337": 38,
			"338": 67,
			"339": 19,
			"340": 48,
			"341": 15,
			"342": 52,
			"352": 10,
			"403": 1,
			"427": 12,
			"443": 40,
			"445": 30,
			"505": 23,
			"506": 18,
			"507": 24,
			"513": 34,
			"514": 6,
			"527": 13,
			"534": 56,
			"535": 57,
			"536": 58,
			"537": 59,
			"538": 20,
			"539": 39,
			"540": 21,
			"543": 64,
			"544": 22,
			"550": 61,
			"551": 60,
			"599": 41,
			"623": 2,
			"627": 37,
			"638": 65,
			"687": 36,
			"688": 14,
			"713": 55,
			"732": 66,
			"739": 9,
			"798": 5,
			"894": 35,
			"1861": 69,
			"1870": 33,
			"1871": 44,
			"1872": 47
		},
		"1": {
			"21": 2,
			"76": 22,
			"83": 15,
			"138": 4,
			"182": 5,
			"190": 14,
			"195": 3,
			"300": 16,
			"310": 17,
			"333": 6,
			"366": 1,
			"508": 19,
			"545": 18,
			"552": 20,
			"557": 7,
			"594": 11,
			"618": 10,
			"708": 21,
			"745": 8,
			"750": 13,
			"759": 12,
			"896": 9
		},
		"2": {
			"22": 2,
			"77": 22,
			"84": 13,
			"139": 4,
			"183": 5,
			"191": 10,
			"196": 3,
			"301": 15,
			"311": 16,
			"334": 14,
			"367": 1,
			"509": 18,
			"546": 17,
			"553": 19,
			"558": 7,
			"595": 9,
			"619": 8,
			"709": 21,
			"746": 6,
			"751": 12,
			"760": 11,
			"897": 20
		},
		"3": {
			"23": 2,
			"78": 22,
			"85": 13,
			"140": 4,
			"184": 5,
			"192": 10,
			"197": 3,
			"302": 15,
			"312": 16,
			"335": 14,
			"368": 1,
			"510": 18,
			"547": 17,
			"554": 19,
			"559": 7,
			"596": 9,
			"620": 8,
			"710": 21,
			"747": 6,
			"752": 12,
			"761": 11,
			"898": 20
		},
		"4": {
			"24": 2,
			"79": 22,
			"86": 13,
			"141": 4,
			"185": 5,
			"193": 10,
			"198": 3,
			"303": 15,
			"313": 16,
			"336": 14,
			"369": 1,
			"511": 18,
			"548": 17,
			"555": 19,
			"560": 7,
			"597": 9,
			"621": 8,
			"711": 21,
			"748": 6,
			"753": 12,
			"762": 11,
			"899": 20
		},
		"5": {
			"25": 2,
			"80": 21,
			"87": 13,
			"142": 4,
			"186": 5,
			"194": 10,
			"199": 3,
			"304": 14,
			"314": 15,
			"370": 1,
			"512": 17,
			"549": 16,
			"556": 18,
			"561": 7,
			"598": 9,
			"622": 8,
			"712": 20,
			"749": 6,
			"754": 12,
			"763": 11,
			"900": 19
		}
	},
	"7": {
		"0": {
			"1": 11,
			"74": 10,
			"103": 74,
			"136": 14,
			"137": 86,
			"256": 15,
			"260": 71,
			"261": 70,
			"278": 36,
			"281": 87,
			"282": 78,
			"306": 19,
			"321": 44,
			"322": 77,
			"323": 42,
			"324": 43,
			"325": 55,
			"326": 73,
			"327": 72,
			"343": 30,
			"345": 28,
			"346": 29,
			"349": 13,
			"412": 97,
			"415": 61,
			"416": 58,
			"417": 18,
			"418": 17,
			"425": 60,
			"426": 68,
			"428": 85,
			"429": 62,
			"432": 84,
			"433": 67,
			"434": 45,
			"435": 49,
			"436": 89,
			"437": 88,
			"439": 41,
			"442": 46,
			"443": 91,
			"462": 48,
			"464": 47,
			"465": 7,
			"515": 66,
			"516": 63,
			"517": 22,
			"518": 21,
			"525": 65,
			"526": 69,
			"528": 59,
			"529": 39,
			"530": 38,
			"531": 40,
			"532": 64,
			"533": 96,
			"599": 90,
			"600": 51,
			"605": 52,
			"614": 4,
			"615": 5,
			"616": 6,
			"617": 76,
			"624": 81,
			"625": 75,
			"626": 50,
			"647": 2,
			"689": 1,
			"693": 32,
			"695": 56,
			"696": 37,
			"697": 25,
			"701": 26,
			"705": 35,
			"706": 34,
			"714": 92,
			"715": 57,
			"720": 82,
			"721": 33,
			"722": 31,
			"723": 83,
			"724": 79,
			"725": 80,
			"726": 93,
			"730": 94,
			"738": 8,
			"795": 54,
			"796": 16,
			"841": 53,
			"862": 12,
			"870": 24,
			"871": 27,
			"872": 3,
			"883": 20,
			"895": 9,
			"902": 23,
			"928": 95
		},
		"1": {
			"21": 4,
			"83": 14,
			"138": 6,
			"182": 7,
			"195": 5,
			"273": 13,
			"419": 1,
			"519": 2,
			"648": 18,
			"664": 3,
			"698": 10,
			"727": 15,
			"729": 16,
			"731": 17,
			"734": 8,
			"756": 9,
			"794": 11,
			"860": 12
		},
		"2": {
			"22": 4,
			"84": 14,
			"139": 6,
			"183": 7,
			"196": 5,
			"274": 13,
			"420": 1,
			"520": 2,
			"649": 16,
			"665": 3,
			"699": 10,
			"728": 15,
			"735": 8,
			"757": 9,
			"859": 11,
			"861": 12
		},
		"3": {
			"2": 3,
			"148": 5,
			"154": 6,
			"160": 4,
			"641": 2,
			"652": 1
		},
		"4": {
			"5": 3,
			"149": 5,
			"155": 6,
			"163": 4,
			"642": 2,
			"655": 1
		},
		"5": {
			"7": 3,
			"150": 5,
			"156": 6,
			"165": 4,
			"643": 2,
			"657": 1
		},
		"6": {
			"151": 5,
			"157": 6,
			"166": 4,
			"644": 2,
			"658": 1,
			"930": 3
		},
		"7": {
			"9": 3,
			"152": 5,
			"158": 6,
			"168": 4,
			"645": 2,
			"660": 1
		},
		"8": {
			"12": 3,
			"153": 5,
			"159": 6,
			"171": 4,
			"646": 2,
			"663": 1
		},
		"9": {
			"66": 2,
			"255": 3,
			"354": 5,
			"355": 6,
			"438": 4,
			"680": 1
		},
		"10": {
			"67": 2,
			"258": 3,
			"356": 4,
			"357": 5,
			"681": 1
		},
		"11": {
			"81": 2,
			"353": 3,
			"440": 4,
			"441": 5,
			"690": 1
		},
		"12": {
			"68": 2,
			"259": 3,
			"682": 1
		},
		"13": {
			"69": 4,
			"146": 1,
			"180": 8,
			"262": 5,
			"650": 2,
			"683": 6,
			"694": 7,
			"740": 3
		},
		"14": {
			"70": 1,
			"263": 2,
			"684": 3
		},
		"15": {
			"72": 1,
			"277": 2,
			"686": 3
		},
		"16": {
			"147": 2,
			"181": 1,
			"275": 5,
			"276": 4,
			"741": 3
		}
	},
	"8": {
		"0": {
			"74": 3,
			"103": 7,
			"256": 5,
			"306": 6,
			"349": 4,
			"443": 8,
			"599": 9,
			"647": 2,
			"689": 1
		},
		"1": {
			"195": 2,
			"664": 1
		},
		"2": {
			"196": 2,
			"665": 1
		},
		"3": {
			"197": 2,
			"666": 1
		},
		"4": {
			"198": 2,
			"667": 1
		}
	},
	"9": {
		"0": {
			"74": 3,
			"256": 5,
			"306": 6,
			"349": 4,
			"443": 7,
			"599": 8,
			"647": 2,
			"689": 1
		},
		"1": {
			"195": 2,
			"664": 1
		},
		"2": {
			"196": 2,
			"665": 1
		}
	},
	"10": {
		"0": {
			"1": 3,
			"74": 2,
			"103": 7,
			"256": 5,
			"306": 6,
			"349": 4,
			"403": 1,
			"443": 8,
			"599": 9
		}
	},
	"11": {
		"0": {
			"74": 2,
			"103": 6,
			"256": 4,
			"306": 5,
			"349": 3,
			"403": 1,
			"443": 7,
			"599": 8
		}
	},
	"12": {
		"0": {
			"74": 3,
			"103": 7,
			"256": 5,
			"306": 6,
			"349": 4,
			"443": 8,
			"599": 9,
			"647": 2,
			"689": 1
		}
	},
	"13": {
		"0": {
			"283": 18,
			"284": 6,
			"285": 7,
			"286": 9,
			"287": 10,
			"288": 2,
			"289": 3,
			"290": 11,
			"291": 12,
			"292": 1,
			"293": 14,
			"294": 13,
			"295": 15,
			"316": 8,
			"452": 4,
			"453": 5,
			"454": 16,
			"455": 17,
			"456": 20,
			"457": 19,
			"458": 23,
			"459": 21,
			"460": 24,
			"461": 22
		}
	},
	"14": {
		"0": {
			"443": 1,
			"599": 2
		}
	},
	"15": {
		"0": {
			"443": 1,
			"599": 2
		}
	},
	"16": {
		"0": {
			"443": 1,
			"599": 2
		}
	},
	"17": {
		"0": {
			"348": 1,
			"443": 2,
			"599": 3
		}
	},
	"18": {
		"0": {
			"65": 12,
			"74": 4,
			"253": 10,
			"256": 6,
			"306": 7,
			"349": 5,
			"350": 17,
			"443": 8,
			"599": 9,
			"601": 3,
			"606": 19,
			"647": 2,
			"679": 11,
			"689": 1,
			"742": 18,
			"797": 13,
			"880": 15,
			"884": 14,
			"895": 16
		},
		"1": {
			"21": 4,
			"195": 2,
			"664": 1,
			"698": 3,
			"734": 5
		},
		"2": {
			"22": 4,
			"196": 2,
			"665": 1,
			"699": 3,
			"735": 5
		},
		"3": {
			"23": 4,
			"197": 2,
			"666": 1,
			"700": 3,
			"736": 5
		}
	},
	"19": {
		"0": {
			"74": 2,
			"103": 7,
			"256": 4,
			"306": 5,
			"349": 3,
			"443": 10,
			"599": 11,
			"606": 6,
			"689": 1,
			"714": 9,
			"902": 8
		},
		"1": {
			"21": 2,
			"138": 5,
			"182": 6,
			"195": 3,
			"664": 1,
			"873": 8,
			"875": 7,
			"877": 4
		},
		"2": {
			"22": 6,
			"196": 1,
			"665": 5,
			"874": 4,
			"876": 3,
			"878": 2
		}
	},
	"20": {
		"0": {
			"74": 2,
			"256": 4,
			"306": 5,
			"349": 3,
			"443": 6,
			"599": 7,
			"689": 1
		},
		"1": {
			"21": 2,
			"138": 4,
			"182": 5,
			"195": 3,
			"664": 1,
			"851": 6
		},
		"2": {
			"22": 2,
			"139": 4,
			"183": 5,
			"196": 3,
			"665": 1,
			"852": 6
		},
		"3": {
			"23": 2,
			"140": 4,
			"184": 5,
			"197": 3,
			"666": 1,
			"853": 6
		},
		"4": {
			"24": 2,
			"141": 4,
			"185": 5,
			"198": 3,
			"667": 1,
			"854": 6
		},
		"5": {
			"25": 4,
			"142": 2,
			"186": 3,
			"199": 1,
			"668": 5,
			"855": 6
		},
		"6": {
			"26": 4,
			"143": 2,
			"187": 3,
			"200": 1,
			"669": 5,
			"856": 6
		},
		"7": {
			"27": 4,
			"144": 2,
			"188": 3,
			"201": 1,
			"670": 5,
			"857": 6
		},
		"8": {
			"28": 4,
			"145": 2,
			"189": 3,
			"202": 1,
			"671": 5,
			"858": 6
		}
	},
	"21": {
		"0": {
			"443": 1,
			"599": 2
		}
	},
	"23": {
		"0": {
			"443": 1,
			"599": 2
		}
	},
	"24": {
		"0": {
			"443": 1,
			"599": 2
		}
	},
	"25": {
		"0": {
			"443": 1,
			"599": 2
		}
	},
	"26": {
		"0": {
			"443": 1,
			"599": 2
		}
	},
	"27": {
		"0": {
			"443": 1,
			"599": 2
		}
	},
	"28": {
		"0": {
			"74": 2,
			"103": 8,
			"256": 4,
			"306": 5,
			"349": 3,
			"403": 1,
			"443": 10,
			"599": 9,
			"603": 12,
			"604": 11,
			"606": 6,
			"926": 7
		}
	},
	"29": {
		"0": {
			"74": 2,
			"254": 4,
			"349": 3,
			"403": 1,
			"443": 5,
			"599": 6
		},
		"1": {
			"21": 2,
			"83": 7,
			"195": 3,
			"366": 1,
			"466": 4,
			"557": 5,
			"799": 6
		},
		"2": {
			"22": 2,
			"84": 7,
			"196": 3,
			"367": 1,
			"467": 4,
			"558": 5,
			"800": 6
		},
		"3": {
			"23": 2,
			"85": 7,
			"197": 3,
			"368": 1,
			"468": 4,
			"559": 5,
			"801": 6
		},
		"4": {
			"24": 2,
			"86": 7,
			"198": 3,
			"369": 1,
			"469": 4,
			"560": 5,
			"802": 6
		},
		"5": {
			"25": 2,
			"87": 7,
			"199": 3,
			"370": 1,
			"470": 4,
			"561": 5,
			"803": 6
		},
		"6": {
			"26": 2,
			"88": 7,
			"200": 3,
			"371": 1,
			"471": 4,
			"562": 5,
			"804": 6
		},
		"7": {
			"27": 2,
			"89": 7,
			"201": 3,
			"372": 1,
			"472": 4,
			"563": 5,
			"805": 6
		},
		"8": {
			"28": 2,
			"90": 7,
			"202": 3,
			"373": 1,
			"473": 4,
			"564": 5,
			"806": 6
		},
		"9": {
			"29": 2,
			"91": 7,
			"203": 3,
			"374": 1,
			"474": 4,
			"565": 5,
			"807": 6
		},
		"10": {
			"30": 2,
			"92": 7,
			"204": 3,
			"375": 1,
			"475": 4,
			"566": 5,
			"808": 6
		},
		"11": {
			"31": 2,
			"93": 7,
			"205": 3,
			"376": 1,
			"476": 4,
			"567": 5,
			"809": 6
		},
		"12": {
			"32": 2,
			"94": 7,
			"206": 3,
			"377": 1,
			"477": 4,
			"568": 5,
			"810": 6
		},
		"13": {
			"33": 2,
			"95": 7,
			"207": 3,
			"378": 1,
			"478": 4,
			"569": 5,
			"811": 6
		},
		"14": {
			"34": 2,
			"96": 7,
			"208": 3,
			"379": 1,
			"479": 4,
			"570": 5,
			"812": 6
		},
		"15": {
			"35": 2,
			"97": 7,
			"209": 3,
			"380": 1,
			"480": 4,
			"571": 5,
			"813": 6
		},
		"16": {
			"36": 2,
			"98": 7,
			"210": 3,
			"381": 1,
			"481": 4,
			"572": 5,
			"814": 6
		},
		"17": {
			"37": 2,
			"99": 7,
			"211": 3,
			"382": 1,
			"482": 4,
			"573": 5,
			"815": 6
		},
		"18": {
			"38": 2,
			"100": 7,
			"212": 3,
			"383": 1,
			"483": 4,
			"574": 5,
			"816": 6
		},
		"19": {
			"39": 2,
			"101": 7,
			"213": 3,
			"384": 1,
			"484": 4,
			"575": 5,
			"817": 6
		},
		"20": {
			"40": 2,
			"104": 7,
			"214": 3,
			"385": 1,
			"485": 4,
			"576": 5,
			"818": 6
		},
		"21": {
			"41": 2,
			"105": 7,
			"215": 3,
			"386": 1,
			"486": 4,
			"577": 5,
			"819": 6
		},
		"22": {
			"42": 2,
			"106": 7,
			"216": 3,
			"387": 1,
			"487": 4,
			"578": 5,
			"820": 6
		},
		"23": {
			"43": 2,
			"107": 7,
			"217": 3,
			"388": 1,
			"488": 4,
			"579": 5,
			"821": 6
		},
		"24": {
			"44": 2,
			"108": 7,
			"218": 3,
			"389": 1,
			"489": 4,
			"580": 5,
			"822": 6
		},
		"25": {
			"45": 2,
			"109": 7,
			"219": 3,
			"390": 1,
			"490": 4,
			"581": 5,
			"823": 6
		},
		"26": {
			"46": 2,
			"110": 7,
			"220": 3,
			"391": 1,
			"491": 4,
			"582": 5,
			"824": 6
		},
		"27": {
			"47": 2,
			"111": 7,
			"221": 3,
			"392": 1,
			"492": 4,
			"583": 5,
			"825": 6
		},
		"28": {
			"48": 2,
			"112": 7,
			"222": 3,
			"393": 1,
			"493": 4,
			"584": 5,
			"826": 6
		},
		"29": {
			"49": 2,
			"113": 7,
			"223": 3,
			"394": 1,
			"494": 4,
			"585": 5,
			"827": 6
		},
		"30": {
			"50": 2,
			"114": 7,
			"224": 3,
			"395": 1,
			"495": 4,
			"586": 5,
			"828": 6
		},
		"31": {
			"51": 2,
			"115": 7,
			"225": 3,
			"396": 1,
			"496": 4,
			"587": 5,
			"829": 6
		},
		"32": {
			"52": 2,
			"116": 7,
			"226": 3,
			"397": 1,
			"497": 4,
			"588": 5,
			"830": 6
		},
		"33": {
			"53": 2,
			"117": 7,
			"227": 3,
			"398": 1,
			"498": 4,
			"589": 5,
			"831": 6
		},
		"34": {
			"54": 2,
			"118": 7,
			"228": 3,
			"399": 1,
			"499": 4,
			"590": 5,
			"832": 6
		},
		"35": {
			"55": 2,
			"119": 7,
			"229": 3,
			"400": 1,
			"500": 4,
			"591": 5,
			"833": 6
		},
		"36": {
			"56": 2,
			"120": 7,
			"230": 3,
			"401": 1,
			"501": 4,
			"592": 5,
			"834": 6
		},
		"37": {
			"57": 2,
			"121": 7,
			"231": 3,
			"402": 1,
			"502": 4,
			"593": 5,
			"835": 6
		}
	},
	"30": {
		"0": {
			"74": 6,
			"103": 28,
			"256": 8,
			"279": 19,
			"306": 9,
			"343": 14,
			"344": 12,
			"346": 15,
			"347": 13,
			"349": 7,
			"350": 11,
			"403": 2,
			"412": 17,
			"415": 25,
			"426": 21,
			"443": 41,
			"446": 32,
			"447": 37,
			"448": 38,
			"449": 31,
			"450": 36,
			"451": 30,
			"515": 26,
			"526": 22,
			"599": 42,
			"601": 4,
			"602": 5,
			"606": 20,
			"617": 40,
			"625": 39,
			"628": 10,
			"647": 3,
			"689": 1,
			"697": 27,
			"701": 16,
			"702": 33,
			"703": 34,
			"704": 35,
			"742": 24,
			"880": 23,
			"895": 29,
			"902": 18
		},
		"1": {
			"21": 2,
			"83": 8,
			"138": 5,
			"182": 6,
			"195": 3,
			"664": 1,
			"698": 9,
			"734": 7,
			"756": 4
		},
		"2": {
			"22": 2,
			"84": 8,
			"139": 5,
			"183": 6,
			"196": 3,
			"665": 1,
			"699": 9,
			"735": 7,
			"757": 4
		},
		"3": {
			"23": 2,
			"85": 8,
			"140": 5,
			"184": 6,
			"197": 3,
			"666": 1,
			"700": 9,
			"736": 7,
			"758": 4
		},
		"4": {
			"3": 3,
			"161": 2,
			"653": 1
		},
		"5": {
			"4": 3,
			"162": 2,
			"654": 1
		},
		"6": {
			"6": 3,
			"164": 2,
			"656": 1
		},
		"7": {
			"8": 3,
			"167": 2,
			"659": 1
		},
		"8": {
			"10": 3,
			"169": 2,
			"661": 1
		},
		"9": {
			"11": 3,
			"170": 2,
			"662": 1
		}
	},
	"31": {
		"0": {
			"60": 33,
			"74": 3,
			"103": 23,
			"137": 28,
			"242": 30,
			"243": 32,
			"244": 40,
			"245": 31,
			"247": 39,
			"256": 13,
			"280": 10,
			"281": 27,
			"306": 14,
			"317": 11,
			"349": 5,
			"403": 1,
			"404": 35,
			"407": 38,
			"408": 37,
			"421": 15,
			"422": 17,
			"423": 8,
			"424": 6,
			"443": 25,
			"444": 21,
			"465": 2,
			"521": 16,
			"522": 18,
			"523": 9,
			"524": 7,
			"599": 26,
			"628": 22,
			"637": 41,
			"674": 34,
			"691": 36,
			"764": 20,
			"773": 4,
			"774": 19,
			"779": 24,
			"879": 12,
			"881": 29
		},
		"1": {
			"21": 2,
			"138": 5,
			"182": 6,
			"195": 3,
			"629": 9,
			"633": 10,
			"664": 1,
			"765": 8,
			"769": 4,
			"775": 7
		},
		"2": {
			"22": 2,
			"139": 5,
			"183": 6,
			"196": 3,
			"630": 9,
			"634": 10,
			"665": 1,
			"766": 8,
			"770": 4,
			"776": 7
		},
		"3": {
			"23": 2,
			"140": 5,
			"184": 6,
			"197": 3,
			"631": 9,
			"635": 10,
			"666": 1,
			"767": 8,
			"771": 4,
			"777": 7
		},
		"4": {
			"24": 2,
			"141": 5,
			"185": 6,
			"198": 3,
			"632": 9,
			"636": 10,
			"667": 1,
			"768": 8,
			"772": 4,
			"778": 7
		},
		"5": {
			"62": 3,
			"233": 5,
			"241": 4,
			"248": 2,
			"406": 6,
			"676": 1
		},
		"6": {
			"61": 3,
			"232": 5,
			"240": 4,
			"246": 2,
			"405": 6,
			"675": 1
		},
		"7": {
			"58": 2,
			"234": 4,
			"236": 5,
			"238": 3,
			"672": 1
		},
		"8": {
			"59": 2,
			"235": 4,
			"237": 5,
			"239": 3,
			"673": 1
		}
	},
	"32": {
		"0": {
			"73": 2,
			"102": 8,
			"256": 11,
			"257": 5,
			"306": 12,
			"307": 6,
			"318": 3,
			"352": 7,
			"403": 1,
			"443": 9,
			"599": 10,
			"739": 4
		},
		"1": {
			"21": 2,
			"122": 6,
			"129": 7,
			"138": 8,
			"182": 9,
			"195": 3,
			"366": 1,
			"557": 4,
			"607": 5
		},
		"2": {
			"22": 2,
			"123": 6,
			"130": 7,
			"139": 8,
			"183": 9,
			"196": 3,
			"367": 1,
			"558": 4,
			"608": 5
		},
		"3": {
			"23": 2,
			"124": 6,
			"131": 7,
			"140": 8,
			"184": 9,
			"197": 3,
			"368": 1,
			"559": 4,
			"609": 5
		},
		"4": {
			"17": 2,
			"176": 3,
			"362": 1
		},
		"5": {
			"13": 2,
			"172": 3,
			"358": 1
		},
		"6": {
			"18": 2,
			"177": 3,
			"363": 1
		},
		"7": {
			"14": 2,
			"173": 3,
			"359": 1
		},
		"8": {
			"19": 2,
			"178": 3,
			"364": 1
		},
		"9": {
			"15": 2,
			"174": 3,
			"360": 1
		}
	},
	"33": {
		"0": {
			"348": 1,
			"443": 2,
			"599": 3
		}
	},
	"34": {
		"0": {
			"1": 6,
			"74": 5,
			"103": 45,
			"136": 9,
			"256": 10,
			"260": 42,
			"261": 41,
			"278": 24,
			"282": 48,
			"306": 13,
			"321": 31,
			"322": 46,
			"323": 29,
			"324": 30,
			"325": 47,
			"326": 44,
			"327": 43,
			"343": 21,
			"345": 19,
			"346": 20,
			"349": 8,
			"415": 35,
			"417": 12,
			"418": 11,
			"425": 34,
			"426": 39,
			"443": 49,
			"515": 38,
			"517": 15,
			"518": 14,
			"525": 37,
			"526": 40,
			"528": 33,
			"529": 27,
			"530": 26,
			"531": 28,
			"532": 36,
			"599": 50,
			"647": 2,
			"689": 1,
			"693": 23,
			"696": 25,
			"697": 17,
			"701": 18,
			"715": 32,
			"722": 22,
			"738": 3,
			"862": 7,
			"895": 4,
			"902": 16
		},
		"1": {
			"21": 4,
			"83": 13,
			"138": 6,
			"182": 7,
			"195": 5,
			"419": 1,
			"519": 2,
			"664": 3,
			"698": 10,
			"734": 8,
			"756": 9,
			"794": 11,
			"860": 12
		},
		"2": {
			"22": 4,
			"84": 12,
			"139": 6,
			"183": 13,
			"196": 5,
			"420": 1,
			"520": 2,
			"665": 3,
			"699": 9,
			"735": 7,
			"757": 8,
			"859": 10,
			"861": 11
		},
		"3": {
			"2": 2,
			"148": 4,
			"154": 5,
			"160": 3,
			"652": 1
		},
		"4": {
			"5": 2,
			"149": 4,
			"155": 5,
			"163": 3,
			"655": 1
		},
		"5": {
			"7": 2,
			"150": 4,
			"156": 5,
			"165": 3,
			"657": 1
		},
		"6": {
			"151": 4,
			"157": 5,
			"166": 3,
			"658": 1,
			"930": 2
		},
		"7": {
			"9": 2,
			"152": 4,
			"158": 5,
			"168": 3,
			"660": 1
		},
		"8": {
			"12": 2,
			"153": 4,
			"159": 5,
			"171": 3,
			"663": 1
		},
		"9": {
			"255": 1
		},
		"10": {
			"353": 1
		}
	},
	"35": {
		"0": {
			"74": 3,
			"256": 5,
			"306": 6,
			"349": 4,
			"426": 8,
			"443": 14,
			"526": 9,
			"599": 15,
			"647": 2,
			"689": 1,
			"701": 10,
			"722": 7,
			"733": 13,
			"862": 12,
			"902": 11
		},
		"1": {
			"21": 2,
			"138": 4,
			"182": 5,
			"195": 3,
			"664": 1
		}
	},
	"36": {
		"0": {
			"74": 4,
			"256": 6,
			"306": 7,
			"349": 5,
			"443": 9,
			"599": 10,
			"601": 3,
			"606": 8,
			"647": 2,
			"689": 1
		},
		"1": {
			"21": 2,
			"195": 3,
			"664": 1
		}
	},
	"37": {
		"0": {
			"443": 1,
			"599": 2
		}
	},
	"38": {
		"0": {
			"74": 4,
			"349": 5,
			"403": 1,
			"413": 7,
			"414": 8,
			"443": 2,
			"599": 3
		}
	},
	"39": {
		"0": {
			"403": 1,
			"443": 2,
			"599": 3
		}
	},
	"40": {
		"0": {
			"443": 3,
			"599": 4,
			"647": 2,
			"689": 1
		}
	},
	"41": {
		"0": {
			"74": 2,
			"103": 19,
			"137": 18,
			"251": 13,
			"252": 14,
			"256": 4,
			"281": 17,
			"306": 5,
			"349": 3,
			"403": 1,
			"409": 6,
			"410": 15,
			"411": 11,
			"430": 7,
			"431": 16,
			"628": 8,
			"692": 12,
			"784": 10,
			"787": 9
		},
		"1": {
			"21": 2,
			"138": 7,
			"182": 8,
			"195": 3,
			"639": 9,
			"664": 1,
			"780": 6,
			"782": 4,
			"785": 5
		},
		"2": {
			"22": 2,
			"139": 7,
			"183": 8,
			"196": 3,
			"640": 9,
			"665": 1,
			"781": 6,
			"783": 4,
			"786": 5
		},
		"3": {
			"64": 1,
			"250": 3,
			"678": 2
		},
		"4": {
			"63": 1,
			"249": 3,
			"677": 2
		}
	},
	"42": {
		"0": {
			"74": 2,
			"349": 1,
			"413": 3,
			"414": 6,
			"443": 4,
			"599": 5
		},
		"1": {
			"557": 1,
			"1865": 2
		},
		"2": {
			"558": 1,
			"1866": 2
		},
		"3": {
			"559": 1,
			"1867": 2
		},
		"4": {
			"560": 1,
			"1868": 2
		},
		"5": {
			"561": 1,
			"1869": 2
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./js/sport-betting/components/grid-control/slot-arrangement-policies/positionCalculators/slot-positions-config.json
// module id = 1828
// module chunks = 2